import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	text: string;
};

export const RelatedEmptyHint: FC<Props> = ({ text }) => {
	const theme = useTheme();

	return (
		<Typography
			variant="caption"
			color={theme.palette.grey[400]}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
		>
			{text}
		</Typography>
	);
};
